<template>
	<div class="dialogBox">
		<el-dialog :title="$t('commissionSettings')" :visible.sync="innerVisible" width="350px" center>
			<div class="content">
				<div class="data">
					<div class="cells">
						<span>{{ $t('UserId') }}:</span>
						<span>{{ form.UserId }}</span>
					</div>
					<!-- <div class="cell">
						<span>当前模式:</span>
						<span v-if="form.IsBaoDi == 1">保底模式</span>
						<span v-else>分成模式</span>
					</div> -->
				</div>
				<div class="setting">
					<span>{{$t('RevenueShareRatio')}}：</span>
					<el-input v-model="form.FenCheng" placeholder="请填写大于0的数值" style="width: 160px"></el-input>
					<span>&nbsp;%</span>
				</div>
				<!-- <div class="tips">
					<span>{{$t('Explanation')}}：</span>
					<p>1. 分层模式为默认模式</p>
					<p>2. 分层模式下，可以设置最低保留区间给下级</p>
					<p>3. 分层模式可以修改为保底模式，保底模式不能转回分层模式</p>
					<p>4. 最低保留设定需大于0</p>
				</div> -->
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="confirmBtn" type="primary" @click="submit(form)" :loading="loading">{{$t('submit')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { app } from '@/api/app.js'
export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		list: {
			type: Object,
			default: '',
		},
	},
	watch: {
		list(val, oldVal) {
			this.form = val
			this.form.FenCheng = Math.floor(val.FenCheng * 1000000) / 10000
		},
	},
	computed: {
		innerVisible: {
			get: function () {
				return this.show
			},
			set: function (val) {
				this.$emit('update:show', val)
			},
		},
	},
	data() {
		return {
			form: {
				UserId: null,
				IsBaoDi: null,
				FenCheng: null,
			},
			loading: false,
		}
	},
	methods: {
		submit(obj) {
			app.getGoogleCode((GoogleCode) => {
				this.loading = true
				const data = {
					SellerId: obj.SellerId,
					UserId: obj.UserId,
					FenCheng: Number(obj.FenCheng / 100),
					GoogleCode: GoogleCode,
				}
				app.post('/agent/set_fencheng', data, (res) => {
					if (res.code == 200) {
						this.innerVisible = false
						this.$message({
							message: '分成设置成功',
							type: 'success',
						})
						this.$emit('updataInfo')
					}
				})
				this.loading = false
			})
		},
	},
}
</script>

<style scoped>
.content {
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.content .cells {
	margin-bottom: 20px;
}

.content .cells span:first-child {
	display: inline-block;
	width: 60px;
	text-align: right;
	margin-right: 10px;
}
.content .tips {
	padding: 10px;
	margin-top: 20px;
	line-height: 24px;
	border: 1px solid #dcdfe6;
	border-radius: 8px;
}
.confirmBtn {
	width: 160px;
	height: 40px;
}
</style>
